<template>
  <b-modal 
    ref="modalAbastecimento" 
    id="modal-abastecimento" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-tint text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">{{ abastecimento.ID ? 'Editar' : 'Novo' }} Abastecimento</h5>
        <small class="text-white opacity-75">Registro de abastecimento do veículo</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Alerta de Título Gerado -->
    <b-alert v-if="tituloGerado" show variant="danger" class="m-3 mb-0">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      Essa movimentação gerou um título no Contas a Pagar com número: <strong>ABT{{ abastecimento.ID }}/1</strong>
    </b-alert>

    <!-- Corpo do Modal -->
    <div class="p-4">
      <div class="modal-section-title mb-3">
        <i class="fa fa-clipboard mr-2 text-primary"></i> Dados da Movimentação
      </div>

      <b-row>
        <b-col md="4">
          <label class="modal-label-premium">Nota Fiscal</label>
          <b-form-input 
            v-model="abastecimento.NOTA_FISCAL" 
            ref="notaFiscal"
            maxlength="20"
            class="rounded-pill shadow-xs"
          ></b-form-input>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Combustível *</label>
          <b-form-select 
            v-model="abastecimento.OP_TIPO_COMBUSTIVEL"
            :state="abastecimento.OP_TIPO_COMBUSTIVEL ? null : false"
            class="rounded-pill shadow-xs"
          >
            <b-form-select-option :value="null">Selecione...</b-form-select-option>
            <b-form-select-option value="1">Gasolina</b-form-select-option>
            <b-form-select-option value="2">Etanol</b-form-select-option>
            <b-form-select-option value="3">Diesel</b-form-select-option>
            <b-form-select-option value="4">Diesel S10</b-form-select-option>
            <b-form-select-option value="5">GNV</b-form-select-option>
            <b-form-select-option value="6">Flex</b-form-select-option>
          </b-form-select>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Data do Abastecimento *</label>
          <cec-input-data
            v-model="abastecimento.DATA" 
            :state="abastecimento.DATA ? null : false"
            input-class="rounded-pill shadow-xs"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="3">
          <label class="modal-label-premium">Litros M3/Litro *</label>
          <vue-autonumeric
            v-model="abastecimento.LITROS"
            @input="calcularTotal"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 3 }"
            :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': !(abastecimento.LITROS > 0), 'is-valid': abastecimento.LITROS > 0 }]"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Preço do Litro *</label>
          <vue-autonumeric
            v-model="abastecimento.PRECO"
            @input="calcularTotal"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2, currencySymbol: 'R$ ', currencySymbolPlacement: 'p' }"
            :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': !(abastecimento.PRECO > 0), 'is-valid': abastecimento.PRECO > 0 }]"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Total R$ *</label>
          <vue-autonumeric
            v-model="abastecimento.TOTAL"
            :disabled="true"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2, currencySymbol: 'R$ ', currencySymbolPlacement: 'p' }"
            class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-success"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Tanque Inicial</label>
          <vue-autonumeric
            v-model="abastecimento.TANQUE_INICIAL"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            class="form-control rounded-pill shadow-xs text-right"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="3">
          <label class="modal-label-premium">Última Km *</label>
          <vue-autonumeric
            v-model="abastecimento.ULTIMA_KM"
            @input="calcularRodou"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': !(abastecimento.ULTIMA_KM > 0), 'is-valid': abastecimento.ULTIMA_KM > 0 }]"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Rodou Km</label>
          <vue-autonumeric
            v-model="abastecimento.RODOU"
            :disabled="true"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            class="form-control rounded-pill shadow-xs bg-light text-right"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Tanque Abastecido</label>
          <vue-autonumeric
            v-model="abastecimento.TANQUE_ABASTECIDO"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            class="form-control rounded-pill shadow-xs text-right"
          />
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-users mr-2 text-primary"></i> Fornecedor e Responsáveis
      </div>

      <b-row>
        <b-col md="4">
          <label class="modal-label-premium">Posto Fornecedor *</label>
          <cliente-pesquisa 
            @retornaId="abastecimento.FORNECEDOR_ID = $event" 
            :idInicial="abastecimento.FORNECEDOR_ID" 
            label="" 
            place="Pesquise o fornecedor"
            :state="abastecimento.FORNECEDOR_ID ? null : false"
            :arredondado="true"
          ></cliente-pesquisa>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Motorista *</label>
          <funcionario-dropdown 
            v-model="abastecimento.MOTORISTA_ID"
            :state="abastecimento.MOTORISTA_ID ? null : false"
            input-class="rounded-pill shadow-xs"
          ></funcionario-dropdown>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Histórico *</label>
          <historico-caixa-dropdown 
            v-model="abastecimento.HISTORICO_ID"
            tipo="DEBITO"
            :state="abastecimento.HISTORICO_ID ? null : false"
            input-class="rounded-pill shadow-xs"
          ></historico-caixa-dropdown>
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-dollar mr-2 text-primary"></i> Detalhes Financeiros
      </div>

      <b-row>
        <b-col md="6">
          <label class="modal-label-premium">Data de Vencimento</label>
          <cec-input-data
            v-model="abastecimento.DATA_VENCIMENTO" 
            input-class="rounded-pill shadow-xs"
          />
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Centro de Custo</label>
          <centro-custo-drop-down 
            v-model="abastecimento.CENTRO_CUSTO_ID"
            input-class="rounded-pill shadow-xs"
          ></centro-custo-drop-down>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="12">
          <label class="modal-label-premium">Observações (Max. 200 caracteres)</label>
          <b-form-textarea 
            v-model="abastecimento.OBSERVACOES" 
            rows="3"
            maxlength="200"
            class="rounded shadow-xs"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </div>

    <!-- Rodapé de Ações -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar">
        <i class="fa fa-check-circle mr-1"></i> {{ abastecimento.ID ? 'ATUALIZAR' : 'SALVAR' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import ClientePesquisa from '../../../pesquisa/ClientePesquisa'
import FuncionarioDropdown from '../../../componentes/dropdown/FuncionarioDropdown.vue'
import HistoricoCaixaDropdown from '../../../componentes/dropdown/HistoricoCaixaDropdown.vue'
import CentroCustoDropDown from '../../../componentes/dropdown/CentroCustoDropDown.vue'
import CecInputData from '../../../../components/Cec/CecInputData.vue'
import Tools from '../../../../tools/Tools'

export default {
  name: 'AbastecimentoModal',
  components: {
    VueAutonumeric,
    ClientePesquisa,
    FuncionarioDropdown,
    HistoricoCaixaDropdown,
    CentroCustoDropDown,
    CecInputData
  },
  props: {
    veiculoId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      abastecimento: this.getNovoAbastecimento(),
      ultimoAbastecimento: null
    }
  },
  computed: {
    tituloGerado () {
      return this.abastecimento.OP_GERA_TITULO === '1' && this.abastecimento.APAGAR_ID > 0
    }
  },
  methods: {
    getNovoAbastecimento () {
      return {
        ID: null,
        VEICULO_ID: this.veiculoId,
        NOTA_FISCAL: '0',
        OP_TIPO_COMBUSTIVEL: null,
        DATA: new Date().toISOString().split('T')[0],
        LITROS: 0,
        PRECO: 0,
        TOTAL: 0,
        TANQUE_INICIAL: 0,
        ULTIMA_KM: 0,
        RODOU: 0,
        TANQUE_ABASTECIDO: 0,
        FORNECEDOR_ID: null,
        MOTORISTA_ID: null,
        HISTORICO_ID: null,
        DATA_VENCIMENTO: null,
        CENTRO_CUSTO_ID: null,
        OBSERVACOES: '',
        OP_GERA_TITULO: '0',
        APAGAR_ID: null
      }
    },
    
    async buscarUltimoAbastecimento () {
      try {
        const result = await this.$http.get(`/api/protected/veiculo/abastecimento/listar/${this.veiculoId}`)
        if (result.data && result.data.length > 0) {
          // Pega o último abastecimento (maior ID ou mais recente)
          const abastecimentos = result.data.sort((a, b) => b.ID - a.ID)
          this.ultimoAbastecimento = abastecimentos[0]
        }
      } catch (error) {
        console.error('Erro ao buscar último abastecimento:', error)
        // Não exibir erro ao usuário, é normal não ter abastecimentos
      }
    },

    calcularTotal () {
      const litros = parseFloat(this.abastecimento.LITROS) || 0
      const preco = parseFloat(this.abastecimento.PRECO) || 0
      
      if (litros > 0 && preco > 0) {
        this.abastecimento.TOTAL = parseFloat((litros * preco).toFixed(2))
      } else {
        this.abastecimento.TOTAL = 0
      }
    },

    calcularRodou () {
      const ultimaKm = parseFloat(this.abastecimento.ULTIMA_KM) || 0
      
      if (ultimaKm <= 0) {
        this.abastecimento.RODOU = 0
        return
      }

      if (this.ultimoAbastecimento && this.ultimoAbastecimento.ULTIMA_KM) {
        const ultimaKmAnterior = parseFloat(this.ultimoAbastecimento.ULTIMA_KM) || 0
        const rodou = ultimaKm - ultimaKmAnterior
        this.abastecimento.RODOU = rodou > 0 ? parseFloat(rodou.toFixed(2)) : 0
      } else {
        this.abastecimento.RODOU = 0
      }
    },

    async abrir (abastecimentoId = null) {
      await this.buscarUltimoAbastecimento()
      
      if (abastecimentoId) {
        await this.carregar(abastecimentoId)
      } else {
        this.abastecimento = this.getNovoAbastecimento()
      }
      
      this.$refs.modalAbastecimento.show()
    },

    async carregar (id) {
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$http.get(`/api/protected/veiculo/abastecimento/${id}`)
        if (result.data) {
          this.abastecimento = { ...result.data }
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar abastecimento')
        console.error(error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async salvar () {
      if (!this.validar()) return

      this.$store.commit('controle/setAguardando', true)
      try {
        const url = this.abastecimento.ID 
          ? '/api/protected/veiculo/abastecimento/edit'
          : '/api/protected/veiculo/abastecimento/post'
        
        const result = await this.$http.post(url, { registro: this.abastecimento })
        
        if (result.data.result === 'sucesso') {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', this.abastecimento.ID ? 'Abastecimento atualizado com sucesso!' : 'Abastecimento cadastrado com sucesso!')
          this.$emit('salvou')
          this.fechar()
        } else {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', result.data.mensagem || 'Erro ao salvar abastecimento')
        }
      } catch (error) {
        const mensagemErro = error.response?.data || error.message || 'Erro ao salvar abastecimento'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagemErro)
        console.error(error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    validar () {
      if (!this.abastecimento.DATA) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a data do abastecimento')
        return false
      }
      if (!this.abastecimento.OP_TIPO_COMBUSTIVEL) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o tipo de combustível')
        return false
      }
      if (!this.abastecimento.LITROS || this.abastecimento.LITROS <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a quantidade de litros')
        return false
      }
      if (!this.abastecimento.TOTAL || this.abastecimento.TOTAL <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'O valor total deve ser maior que zero')
        return false
      }
      if (!this.abastecimento.PRECO || this.abastecimento.PRECO <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o preço do litro')
        return false
      }
      if (!this.abastecimento.ULTIMA_KM || this.abastecimento.ULTIMA_KM <= 0) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a quilometragem atual')
        return false
      }
      if (!this.abastecimento.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o posto fornecedor')
        return false
      }
      if (!this.abastecimento.MOTORISTA_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o motorista')
        return false
      }
      if (!this.abastecimento.HISTORICO_ID) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o histórico de lançamento')
        return false
      }
      return true
    },

    fechar () {
      this.$refs.modalAbastecimento.hide()
    },

    onModalShown () {
      this.$nextTick(() => {
        if (this.$refs.notaFiscal) {
          this.$refs.notaFiscal.focus()
        }
      })
    },

    onModalHidden () {
      this.abastecimento = this.getNovoAbastecimento()
      this.ultimoAbastecimento = null
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.modal-footer-premium {
  border-top: 1px solid #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/veiculo/components/AbastecimentoModal.vue